import styles from './Search.module.scss';
import React, { forwardRef } from 'react';
import { Button, FontAwesomeProIcon } from '@wienenergiegithub/ui-next';
import {
  Button as BaseButton,
  VisuallyHidden,
  FormInput,
  FormLabel,
  FormSubmit,
} from '@ariakit/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Search = forwardRef(
  (
    {
      className,
      onClearSearch,
      outlineColor = 'white',
      placeholder = 'Themen, Problem, Stichwort…',
      store,
      triggerShake = false,
    },
    ref,
  ) => {
    const handleClearSearch = () => {
      if (onClearSearch) {
        onClearSearch();
      }
    };

    return (
      <div
        className={classNames(
          styles.form,
          {
            [styles.shakeAnimation]: triggerShake,
            'shake-animation': triggerShake,
          },
          className,
        )}
      >
        <VisuallyHidden>
          <FormLabel name="s" store={store}>
            Suchbegriff
          </FormLabel>
        </VisuallyHidden>
        <FontAwesomeProIcon
          className={styles.magnifyingGlass}
          icon="search"
          role="presentation"
          size="2x"
          type="regular"
        />
        <FormInput
          className={classNames(styles.input, {
            [styles[outlineColor]]: outlineColor,
          })}
          name="s"
          placeholder={placeholder}
          ref={ref}
          store={store}
          type="search"
        />
        <FormSubmit
          render={
            <Button
              aria-label="Suche starten"
              className={styles.searchButton}
              variant="bubble"
            />
          }
          store={store}
        >
          <FontAwesomeProIcon icon="chevron-right" role="presentation" />
        </FormSubmit>
        <BaseButton
          aria-label="Sucheingabe löschen"
          className={classNames(styles.clearSearchButton, {
            [styles.hidden]: store.getValue('s') === '',
          })}
          onClick={handleClearSearch}
        >
          <FontAwesomeProIcon
            className={styles.clearSearchIcon}
            icon="times"
            role="presentation"
            type="regular"
          />
        </BaseButton>
      </div>
    );
  },
);

Search.propTypes = {
  className: PropTypes.string,
  onClearSearch: PropTypes.func,
  outlineColor: PropTypes.string,
  placeholder: PropTypes.string,
  /* eslint-disable react/forbid-prop-types */
  /** `useDialogStore()` return value from `@ariakit/react` */
  store: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
  triggerShake: PropTypes.bool,
};

Search.displayName = 'Search';

export default Search;
